export default __webpack_public_path__ + "static/media/sample_show.8a0fc40e.xlsx";